// extracted by mini-css-extract-plugin
export default {"root":"rJOVDWsZpCII9xhSfV7w","timeControl":"FtxkczVxuGofBbgT3a8a"};